export default __webpack_public_path__ + "static/media/no-sound.434cb154.mp3";